import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { getAllCategoriesWithEmojis, emojiData } from '../data/emojiData';

const Home = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const categoriesWithEmojis = getAllCategoriesWithEmojis();
  
  // Filter emojis based on search query
  const filteredEmojis = searchQuery 
    ? emojiData.filter(emoji => 
        emoji.keyword.toLowerCase().includes(searchQuery.toLowerCase()) ||
        emoji.description.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const handleSearch = (e) => {
    e.preventDefault();
    // Search functionality is implemented in the state already
    console.log("Searching for:", searchQuery);
  };

  return (
    <main>
      <section className="hero">
        <div className="container">
          <h1>
            <span className="emoji">😊</span>
            <span>GifsCopyPaste.com - Copy and Paste Emojis with Ease</span>
            <span className="emoji">😊</span>
          </h1>
          <p>Your ultimate resource for emoji copy and paste. Express yourself with our vast collection of emojis, symbols, and text templates.</p>
          <div className="search-container">
            <form onSubmit={handleSearch}>
              <input 
                type="text" 
                className="search-input" 
                placeholder="Search emojis, symbols, or templates..." 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="search-button">🔍</button>
            </form>
          </div>
        </div>
      </section>

      {searchQuery && (
        <section className="search-results">
          <div className="container">
            <h2 className="section-title">Search Results for "{searchQuery}"</h2>
            {filteredEmojis.length > 0 ? (
              <div className="emoji-grid">
                {filteredEmojis.map(emoji => (
                  <Link to={`/emoji/${emoji.id}`} key={emoji.id} className="emoji-card">
                    <div className="emoji-big">{emoji.emoji}</div>
                    <h3>{emoji.keyword}</h3>
                    <p>Click to copy</p>
                  </Link>
                ))}
              </div>
            ) : (
              <p className="no-results">No results found. Try a different search term.</p>
            )}
          </div>
        </section>
      )}

      {!searchQuery && (
        <>
          <section className="featured-categories">
            <div className="container">
              <h2 className="section-title">Featured Categories</h2>
              <div className="card-grid">
                {Object.keys(categoriesWithEmojis).map(categoryId => {
                  const category = categoriesWithEmojis[categoryId];
                  return (
                    <Link to={`/category/${categoryId}`} key={categoryId} className="category-card">
                      <span className="category-icon">{category.icon}</span>
                      <h3>{category.name}</h3>
                      <p>{category.description}</p>
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>

          <section className="popular-emojis">
            <div className="container">
              <h2 className="section-title">Popular Emojis</h2>
              <div className="emoji-grid">
                {emojiData.slice(0, 12).map(emoji => (
                  <Link to={`/emoji/${emoji.id}`} key={emoji.id} className="emoji-card">
                    <div className="emoji-big">{emoji.emoji}</div>
                    <h3>{emoji.keyword}</h3>
                    <p>Click to copy</p>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </>
      )}
    </main>
  );
};

export default Home;
